import { useTranslation } from "next-i18next";
import { Language } from "../../config/LanguageConfiguration";

export const useI18nActiveLanguage = (): Language => {
  return useTranslation<"common">().i18n.language as Language;
};
